"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInLambda = void 0;
const isInLambda = () => { var _a; return Boolean(typeof process !== 'undefined' && ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.LAMBDA_TASK_ROOT)); };
exports.isInLambda = isInLambda;
